import React from "react";
import { Skeleton } from "../ui/skeleton";

const ProductDetailSkeleton = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Title Skeleton */}
      <div className=" space-y-4">
        <Skeleton className="h-[38px] w-full rounded-md lg:h-[36px]" />
        <Skeleton className="h-[38px] w-[80%] rounded-md lg:h-[36px]" />
      </div>

      {/* Product Details Skeleton */}
      <div className="p-6 border border-gray1 rounded-[16px] flex gap-6">
        <Skeleton className="h-[580px] w-[25%] rounded-[16px]" />
        <Skeleton className="h-[580px] w-full rounded-[16px]" />
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
